export const reset = type => dispatch => {
    dispatch({
      type,
      payload: null
    });
  };
  
